const PAYMENTS_QUERY_STALE_TIME = 10 * 60 * 1000; // 10 minutes

export { PAYMENTS_QUERY_STALE_TIME };

export const WALLET_BALANCE_QUERY_KEY = 'wallets/balance';

export const walletBalanceQueryKey = (userId?: string) =>
  [WALLET_BALANCE_QUERY_KEY, userId] as const;

// eslint-disable-next-line no-restricted-syntax
export enum CognitoGroups {
  SPLADMINS = 'Spladmins',
  INTERNAL_OPS = 'InternalOps',
  VIP = 'vip',
}
